export default __webpack_public_path__ + "ccda4258a5d8eb896ba0d87196ccdc4e.svg";